import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { FileSpreadsheet, Loader2 } from "lucide-react";

const firstOfYear = () => `${new Date().getFullYear()}-01-01`;
const today = () => new Date().toISOString().slice(0, 10);

export default function ExportCsvButton() {
  const [open, setOpen] = useState(false);
  const [du, setDu] = useState(firstOfYear());
  const [au, setAu] = useState(today());
  const [immeuble, setImmeuble] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get("/export/frais.csv", { params: { du, au, immeuble: immeuble || undefined }, responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "frais-locataires.csv";
      const u = URL.createObjectURL(r.data);
      Object.assign(document.createElement("a"), { href: u, download: name }).click();
      setTimeout(() => URL.revokeObjectURL(u), 5000);
      toast.success("Export CSV généré");
      setOpen(false);
    } catch { toast.error("Impossible de générer l'export"); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="h-11 border-dd-blue text-dd-blue" data-testid="export-csv-btn">
        <FileSpreadsheet size={18} className="mr-2" /> Export comptable
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="export-dialog">
          <DialogHeader><DialogTitle className="text-dd-blue">Export comptable (CSV)</DialogTitle></DialogHeader>
          <p className="text-sm text-dd-warm">Montants à charge des locataires (observations imputées au locataire des états des lieux de sortie), une ligne par défaut, triés par immeuble. Séparateur « ; », compatible Excel.</p>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-dd-night">Du</Label><Input type="date" value={du} onChange={(e) => setDu(e.target.value)} className="h-11 mt-1" data-testid="export-du" /></div>
            <div><Label className="text-dd-night">Au</Label><Input type="date" value={au} onChange={(e) => setAu(e.target.value)} className="h-11 mt-1" data-testid="export-au" /></div>
            <div className="col-span-2"><Label className="text-dd-night">Immeuble (facultatif)</Label><Input value={immeuble} onChange={(e) => setImmeuble(e.target.value)} placeholder="Tous les immeubles" className="h-11 mt-1" data-testid="export-immeuble" /></div>
          </div>
          <DialogFooter>
            <Button onClick={run} disabled={busy} className="h-11 bg-dd-blue hover:bg-dd-hover text-white" data-testid="export-confirm">
              {busy ? <Loader2 size={16} className="mr-1 animate-spin" /> : <FileSpreadsheet size={16} className="mr-1" />} Télécharger le CSV
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
